//* ============================================================
//* Webshop Product Filter Binding Override
//* ============================================================

(() => {
    frappe.ready(() => {
        const Orig = webshop.ProductView;
        if (!Orig) return;
        class ProductViewPatched extends Orig {
            /**
             * Overrides the default ProductView filter binding logic.
             *
             * Additional handling:
             * - variant attribute filters (checkbox & radio)
             *
             * This override extends the default webshop filtering
             * to support custom attribute-based filtering.
             *
             * Updates internal filter state and triggers route changes
             * whenever a filter is modified.
             */

            bind_filters(){
                let me = this;
                this.field_filters = {};
                this.attribute_filters = {};

                $('.product-filter').off('change.custom').on('change.custom', (e) => {
                    me.from_filters = true;

                    const $checkbox = $(e.target);
                    const is_checked = $checkbox.is(':checked');

                    if ($checkbox.is('.attribute-filter')) {
                        const {
                            attributeName: attribute_name,
                            attributeValue: attribute_value
                        } = $checkbox.data();

                        if ($checkbox.attr("type") === "radio") {
                            this.attribute_filters[attribute_name] = [attribute_value];
                            me.change_route_with_filters();
                            return;
                        }

                        if (is_checked) {
                            this.attribute_filters[attribute_name] =
                                this.attribute_filters[attribute_name] || [];
                            this.attribute_filters[attribute_name].push(attribute_value);
                        } else {
                            this.attribute_filters[attribute_name] =
                                (this.attribute_filters[attribute_name] || [])
                                    .filter(v => v !== attribute_value);
                        }

                        if (!this.attribute_filters[attribute_name]?.length) {
                            delete this.attribute_filters[attribute_name];
                        }
                    } else if (
                        $checkbox.is('.field-filter') ||
                        $checkbox.is('.discount-filter')
                    ) {
                        const {
                            filterName: filter_name,
                            filterValue: filter_value
                        } = $checkbox.data();

                        if ($checkbox.is('.discount-filter')) {
                            delete this.field_filters["discount"];
                        }

                        if (is_checked) {
                            this.field_filters[filter_name] =
                                this.field_filters[filter_name] || [];
                            if (!in_list(this.field_filters[filter_name], filter_value)) {
                                this.field_filters[filter_name].push(filter_value);
                            }
                        } else {
                            this.field_filters[filter_name] =
                                (this.field_filters[filter_name] || [])
                                    .filter(v => v !== filter_value);
                        }

                        if (!this.field_filters[filter_name]?.length) {
                            delete this.field_filters[filter_name];
                        }
                    }

                    me.change_route_with_filters();
                });

                $('.filter-lookup-input').on(
                    'keydown',
                    frappe.utils.debounce((e) => {
                        const $input = $(e.target);
                        const keyword = ($input.val() || '').toLowerCase();
                        const $filter_options = $input.next('.filter-options');

                        $filter_options.find('.filter-lookup-wrapper').show();
                        $filter_options.find('.filter-lookup-wrapper').each((i, el) => {
                            const $el = $(el);
                            const value = ($el.data('value') || '').toLowerCase();
                            if (!value.includes(keyword)) {
                                $el.hide();
                            }
                        });
                    }, 300)
                );
            }

            get_item_filter_data(from_filters=false) {
                // Get and render all Product related views
                let me = this;
                this.from_filters = from_filters;
                let args = this.get_query_filters();

                this.disable_view_toggler(true);
                this._show_skeleton();

                // Rapid filter clicks fire one request per click. Cancel the
                // previous one, otherwise a slower earlier response can arrive
                // last and render items that no longer match the active filters.
                if (this.filter_request && this.filter_request.abort) {
                    this.filter_request.abort();
                }

                this.filter_request = frappe.call({
                    method: "webshop.webshop.api.get_product_filter_data",
                    args: {
                        query_args: args
                    },
                    callback: function(result) {
                        me.filter_request = null;
                        me._hide_skeleton();
                        if (!result || result.exc || !result.message || result.message.exc) {
                            me.render_no_products_section(true);
                        } else {
                            // Sub Category results are independent of Items
                            if (me.item_group && result.message["sub_categories"].length) {
                                me.render_item_sub_categories(result.message["sub_categories"]);
                            }

                            if (!result.message["items"].length) {
                                // if result has no items or result is empty
                                me.render_no_products_section();
                            } else {
                                // Add discount filters
                                me.re_render_discount_filters(result.message["filters"].discount_filters);

                                // bulk_prices_html is already embedded in each item by the server
                                // — no second round-trip needed

                                // Render views
                                me.render_list_view(result.message["items"], result.message["settings"]);
                                me.render_grid_view(result.message["items"], result.message["settings"]);
                                me.render_single_view(result.message["items"], result.message["settings"]);

                                me.products = result.message["items"];
                                me.product_count = result.message["items_count"];
                            }

                            // Bind filter actions
                            if (!from_filters) {
                                // If `get_product_filter_data` was triggered after checking a filter,
                                // don't touch filters unnecessarily, only data must change
                                // filter persistence is handle on filter change event
                                me.bind_filters();
                                me.restore_filters_state();
                            }

                            // Bottom paging
                            me.add_paging_section(result.message["settings"]);
                        }

                        me.disable_view_toggler(false);
                    }
                });
            }

            // ── Single view ──────────────────────────────────────────────

            render_single_view(items, settings) {
                // Don't use the base prepare_product_area_wrapper — it adds Bootstrap
                // "row" class which breaks height inheritance for the single view.
                if (!$("#products-single-area").length) {
                    this.products_section.append(
                        `<div id="products-single-area" class="mt-minus-1"></div>`
                    );
                }
                new webshop.ProductSingle({
                    query_args: this.get_query_filters(),
                    products_section: $("#products-single-area"),
                    settings: settings,
                    preference: this.preference
                });
            }

            // ── View toggler overrides ───────────────────────────────────

            render_view_toggler() {
                $(".toolbar").append(`<div class="toggle-container col-4 p-0"></div>`);

                // Single view button (leftmost)
                $(".toggle-container").append(`
                    <div class="form-group mb-0" id="toggle-view">
                        <button id="single-view" class="btn btn-single-view mr-2"
                            title="${ __("Single View") }">
                            <span>
                                <svg class="icon icon-md" viewBox="0 0 16 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2" y="2" width="12" height="12" rx="1.5"
                                        stroke="currentColor" stroke-width="1.5"/>
                                </svg>
                            </span>
                        </button>
                    </div>
                `);

                // Grid + List buttons (existing icons)
                ["btn-grid-view", "btn-list-view"].forEach(view => {
                    let icon = view === "btn-list-view" ? "list" : "image-view";
                    let id   = view === "btn-list-view" ? "list" : "image-view";
                    $(".toggle-container").append(`
                        <div class="form-group mb-0" id="toggle-view">
                            <button id="${ id }" class="btn ${ view } mr-2">
                                <span>
                                    <svg class="icon icon-md">
                                        <use href="#icon-${ icon }"></use>
                                    </svg>
                                </span>
                            </button>
                        </div>
                    `);
                });
            }

            bind_view_toggler_actions() {
                const me = this;

                $("#single-view").click(function() {
                    $(this).addClass("btn-primary");
                    $(".btn-grid-view, .btn-list-view").removeClass("btn-primary");
                    $("#products-grid-area, #products-list-area").addClass("hidden");
                    $(".product-paging-area").hide();
                    localStorage.setItem("product_view", "Single View");
                    me.preference = "Single View";

                    // Re-instantiate to fetch all items if not already done
                    const $area = $("#products-single-area");
                    if ($area.find(".ws-single-view").length === 0) {
                        $area.removeClass("hidden");
                        new webshop.ProductSingle({
                            query_args: me.get_query_filters(),
                            products_section: $area,
                            settings: me.settings,
                            preference: "Single View"
                        });
                    } else {
                        $area.removeClass("hidden");
                    }
                });

                $("#list").click(function() {
                    $(this).addClass("btn-primary");
                    $("#single-view").removeClass("btn-primary");
                    $(".btn-grid-view").removeClass("btn-primary");
                    $("#products-grid-area, #products-single-area").addClass("hidden");
                    $("#products-list-area").removeClass("hidden");
                    $(".product-paging-area").show();
                    localStorage.setItem("product_view", "List View");
                    me.preference = "List View";
                });

                $("#image-view").click(function() {
                    $(this).addClass("btn-primary");
                    $("#single-view").removeClass("btn-primary");
                    $(".btn-list-view").removeClass("btn-primary");
                    $("#products-list-area, #products-single-area").addClass("hidden");
                    $("#products-grid-area").removeClass("hidden");
                    $(".product-paging-area").show();
                    localStorage.setItem("product_view", "Grid View");
                    me.preference = "Grid View";
                });
            }

            set_view_state() {
                if (this.preference === "List View") {
                    $("#list").addClass("btn-primary");
                    $("#image-view, #single-view").removeClass("btn-primary");
                } else if (this.preference === "Single View") {
                    $("#single-view").addClass("btn-primary");
                    $("#image-view, #list").removeClass("btn-primary");
                } else {
                    $("#image-view").addClass("btn-primary");
                    $("#list, #single-view").removeClass("btn-primary");
                }
            }

            disable_view_toggler(disable = false) {
                $("#list, #image-view, #single-view").prop("disabled", disable);
            }

            _show_skeleton() {
                // Remove any existing skeleton first
                $('#ws-product-skeleton').remove();

                // Match the current page_length setting (default 9)
                const count = (this.settings && this.settings.products_per_page) || 9;
                let cards = '';
                for (let i = 0; i < count; i++) {
                    cards += `
                        <div class="col-6 col-md-4 mb-4">
                            <div class="ws-skeleton-card">
                                <div class="ws-skel ws-skel-img"></div>
                                <div class="ws-skel-body">
                                    <div class="ws-skel ws-skel-line ws-skel-title"></div>
                                    <div class="ws-skel ws-skel-line ws-skel-sub"></div>
                                    <div class="ws-skel ws-skel-line ws-skel-price"></div>
                                    <div class="ws-skel-actions">
                                        <div class="ws-skel ws-skel-btn"></div>
                                    </div>
                                </div>
                            </div>
                        </div>`;
                }

                const $skeleton = $(`
                    <div id="ws-product-skeleton" class="row mt-3">
                        ${cards}
                    </div>
                `);

                // Insert skeleton into the product listing area
                $('#product-listing').append($skeleton);
            }

            _hide_skeleton() {
                $('#ws-product-skeleton').remove();
            }

            add_paging_section(settings) {
                // Hide standard paging in single view — navigation is via Prev/Next arrows
                if (this.preference === "Single View") {
                    $(".product-paging-area").remove();
                    return;
                }
                super.add_paging_section(settings);
            }

        }
        webshop.ProductView = ProductViewPatched;
    });
})();
